{
  "data_driven": {
    "formula_applied": "Formule appliquée",
    "by_attributes": "Par attributs",
    "any_others": "Tous les autres"
  },
  "styles2": {
    "bold": "AUDACIEUX",
    "regular": "Régulier",
    "on": "Sur",
    "off": "Off",
    "arrow_spacing": "Espacement des flèches",
    "arrow_colour": "Couleur de la flèche",
    "arrow_size": "Taille de la flèche",
    "arrow_opacity": "Opacité de la flèche",
    "rotation": "Rotation",
    "rotate_icon": "Icône de rotation",
    "orientation_3d": "Orientation 3D",
    "flat": "Appartement",
    "raised": "Élevé",
    "degrees": "Diplômes",
    "model": "modèle",
    "type": "Tapez",
    "scale": "Échelle",
    "choose_model": "Choisissez le modèle",
    "error_loading_models": "Une erreur s'est produite lors du chargement des modèles 3D",
    "solid": "Solide",
    "dashed": "En pointillé",
    "type_of_line": "Type de ligne",
    "Line": "Ligne",
    "Area": "Région",
    "Point": "Point",
    "Icon": "Icône",
    "Model": "modèle",
    "LineModel": "Gamme de modèles 3D",
    "AreaModel": "Domaine des modèles 3D",
    "spacing": "Espacement",
    "plural": {
      "Icon": "Icônes",
      "Point": "Points"
    }
  },
  "object": {
    "deleteTitle": "Supprimer le ou les objets sélectionnés",
    "deleteDescription": "Êtes-vous sûr de vouloir supprimer le ou les objets sélectionnés ?",
    "deleteToast": "{{ count }} objets supprimés",
    "multiple": "Multiple",
    "multiple_objects": "Objets multiples"
  },
  "controls": {
    "draw": "Dessiner",
    "copy": "Copier",
    "select": "Sélectionnez (couches actives)",
    "area_select": "Sélectionnez (Toutes les couches)",
    "area_select_invalid": "La zone dessinée doit avoir 3 points ou plus pour être valide",
    "analysis": "Analyse",
    "search": "Rechercher",
    "grab": "Prenez",
    "toggle_3d_terrain": "Terrain en 3D",
    "toggle_globe": "Vue du globe",
    "toggle_3d_buildings": "Bâtiments 3D",
    "zoom_in": "Zoomer",
    "zoom_out": "Zoom arrière",
    "reset": "Réinitialiser la vue",
    "vr": "Jumeau numérique",
    "comments": "Commentaires",
    "calendar": "Calendrier",
    "zoom_to_all_objects": "Zoomer sur tous les objets",
    "no_objects_to_zoom": "Aucun objet visible sur le plan",
    "bookmarks": "Signets"
  },
  "analysis": {
    "analysis_title": "Outils d'analyse",
    "distance_title": "Distance",
    "distance_description": "Mesurez la distance le long d'une ligne",
    "distance_content": {
      "title": "Distance totale de la ligne de référence sur la carte"
    },
    "walk_time_title": "Temps de marche",
    "walk_time_description": "Calculez le temps de marche le long d'une ligne",
    "walk_time_content": {
      "title": "Durée totale du trajet à pied",
      "approx_time": "Environ {{ speed }} minutes à",
      "m_per_second": "m/seconde"
    },
    "flow_rate_title": "Débit",
    "flow_rate_description": "Flux calculé de personnes franchissant une barrière (ligne tracée sur la carte)",
    "flow_rate_content": {
      "total_width": "Largeur totale de la porte (longueur de la ligne)",
      "per_minute_per_hour": "{{ perMinute }} par {{ perHour }} par heure",
      "at": "à",
      "people_meter_minute": "personnes/mètre/minute",
      "fruin_service_levels": "Niveaux de service Fruit"
    },
    "area_title": "Région",
    "area_description": "Mesurer la zone au sein d'une forme sur la carte",
    "area_content": {
      "title": "Surface totale du polygone de référence sur la carte"
    },
    "capacity_content": {
      "total_area": "Superficie totale",
      "per_m_sq": "{{ perMSq }} par m²",
      "at": "à",
      "people_meter_sq": "m²/personne",
      "people_ft_sq": "ft²/personne",
      "fruin_service_levels": "Niveaux de service Fruit"
    },
    "capacity_title": "Capacité",
    "capacity_description": "Calculez la capacité d'accueil (personnes) d'une zone sur la carte",
    "count_title": "Compter",
    "count_description": "Comptez les objets dans une zone de la carte",
    "count_content": {
      "total": "Total",
      "current_level": "Niveau actuel",
      "all_levels": "Tous les niveaux"
    }
  },
  "styles": {
    "line_fill": "Remplissage de la ligne",
    "colour": "Couleur",
    "colours": "Couleurs",
    "opacity": "Opacité",
    "blur": "Flou",
    "measurement": "Mesure",
    "width": "Largeur",
    "offset": "Offset",
    "join_and_end": "Extrémités et jointures",
    "join": "Rejoint",
    "end": "Se termine",
    "arrows": "Flèches",
    "line_terminator_icon": "Icône (s) de fin de ligne",
    "line_terminator_icon_start": "Démarrer",
    "line_terminator_icon_end": "Fin",
    "line_terminator_icon_both": "Les deux",
    "text": "Texte",
    "text_colour": "Couleur du texte",
    "text_font": "Police de texte",
    "text_weight": "Poids du texte",
    "text_size": "Taille du texte",
    "text_overlap": "Superposition de texte",
    "allow_text_overlap": "Afficher tout",
    "no_text_overlap": "Combinez",
    "text_outline_width": "Largeur du contour du texte",
    "text_outline_colour": "Couleur du contour du texte",
    "text_opacity": "Opacité du texte",
    "text_content": "Contenu textuel",
    "outline": "Schéma",
    "outline_type": "Type de plan",
    "outline_colour": "Couleur du contour",
    "outline_opacity": "Opacité du contour",
    "outline_width": "Largeur du contour",
    "outline_blur": "Flou des contours",
    "no_colour": "Pas de couleur",
    "company_palette": "Palette d'entreprise",
    "type_of_area": "Type de zone",
    "area_2d": "Zone 2D",
    "area_3d": "Zone 3D",
    "height": "Hauteur",
    "type_of_point": "Type de point",
    "point_fill": "Remplissage de points",
    "radius": "Rayon",
    "pitch_alignment": "Orientation 3D",
    "area_fill": "Remplissage de la zone",
    "placement": "Placement",
    "pitch_alignment_map": "Appartement",
    "pitch_alignment_viewport": "Élevé",
    "pitch_alignment_map_desc": "{{ styleType }} se trouve à plat sur le plan de la carte",
    "pitch_alignment_viewport_desc": "{{ styleType }} sera toujours face à la caméra",
    "icon": "Icône",
    "icon_image": "Image d'icône",
    "icon_size": "Taille",
    "icon_colour": "Couleur",
    "icon_opacity": "Opacité",
    "rotation": "Rotation",
    "allow_overlap": "Superposition d'icônes",
    "show_all": "Afficher tout",
    "combine": "Combinez",
    "choose_icon_image": "Choisissez l'image de l'icône",
    "open_icon_selector": "Ouvrir le sélecteur d'icônes",
    "spacing": "Espacement",
    "model_offset": "Offset du modèle",
    "line_model_line_colour": "Couleur de la ligne",
    "line_model_line_width": "Largeur de ligne",
    "type": "Type de ligne",
    "line_model_line_type": "Type de ligne"
  }
}